export enum TipoUrlFacturaFirma {
  PDF = 0,
  IMG = 1,
}
